/**
 * Runtime configuration. The PartyKit room URL has the shape
 *   ws[s]://<host>/parties/<party-name>/<room-code>
 * — `<party-name>` is `main` (the default export of apps/server/src/party.ts;
 * partykit.json `name` = "hookum" identifies the deployed project, not the
 * party name on the URL).
 *
 * The base (everything up to `/parties/...`) is read from
 * `VITE_HOOKUM_WS_BASE`, falling back to `ws://127.0.0.1:1999` for `partykit
 * dev`. We always emit `wss://` over https pages even if the env says `ws`
 * (Mixed Content would block it otherwise — silently breaking prod).
 */

const DEV_DEFAULT = "ws://127.0.0.1:1999";
const PARTY_NAME = "main";

function envBase(): string {
  // Vite + vitest both populate `import.meta.env`; the vite-env.d.ts ambient
  // typing makes `VITE_HOOKUM_WS_BASE` a `string | undefined`.
  const fromEnv = import.meta.env?.VITE_HOOKUM_WS_BASE;
  return (fromEnv ?? DEV_DEFAULT).replace(/\/+$/, "");
}

function upgradeIfHttps(url: string): string {
  if (
    typeof window !== "undefined" &&
    window.location?.protocol === "https:" &&
    url.startsWith("ws://")
  ) {
    return "wss://" + url.slice("ws://".length);
  }
  return url;
}

export function roomSocketUrl(code: string): string {
  const base = upgradeIfHttps(envBase());
  return `${base}/parties/${PARTY_NAME}/${encodeURIComponent(code)}`;
}
